import { GridColDef } from '@mui/x-data-grid-premium'

const classification: GridColDef = {
	field: 'productClass.classification',
	headerName: 'Classification',
	flex: 1,
	sortable: false,
	valueGetter: ( _value, row ) => row.productClass?.classification ?? '',
}

export default classification